import { forwardRef, useContext, useRef, useState } from "react";
import { useDeviceContext } from "src/context/device-context";
import useClickAway from "src/hooks/useClickAway";
import useMousedownAway from "src/hooks/useMousedownAway";

import classes from "./SearchFormInput.module.css";
import { ModalElementContext } from "src/context/modal-element-context";

export const DesktopSearchFormInput = forwardRef(function DesktopSearchFormInput(
  { id, value, iata, label, placeholder, onChangeInput, onClick, className },
  ref,
) {
  const { isMobile } = useDeviceContext();
  const { onClose } = useContext(ModalElementContext);
  const inputRef = useRef(null);

  const [hasFocus, setHasFocus] = useState(null);
  const [clickCount, setClickCount] = useState(0);

  const classname = !isMobile ? className : classes.active;

  const onSelectText = (clickEvent) => {
    console.log(clickCount);
    if (inputRef.current && clickCount === 0) {
      inputRef.current.select();
    } else if (inputRef.current) {
      if (!inputRef.current.contains(clickEvent.target)) {
        console.log(value);
        inputRef.current.setSelectionRange(value.length, value.length);
      }
      inputRef.current.focus();
      console.log("should focus input " + clickCount);
    }
    setClickCount((p) => p + 1);
  };

  const onChangeHandler = (e) => {
    onChangeInput(e.target.value);
  };

  const onClickInputHandler = (e) => {
    setHasFocus(true);
    onSelectText(e);
    if (clickCount > 0) return;
    onClick(false);
  };

  const resetClickCount = () => setClickCount(0);
  useMousedownAway(inputRef, resetClickCount);
  useClickAway(inputRef, resetClickCount);

  const closeDropdown = () => {
    resetClickCount();
    onClose();
  };

  return (
    <label
      ref={(r) => {
        ref[id === "src-location" ? "src" : "dest"] = r;
      }}
      htmlFor={id}
      id={"search-form-input-" + id}
      className={`${classes.frame} ${classname ?? ""} frame-sf-field`}
      onKeyDown={(e) => ["Tab", "Escape"].includes(e.key) && closeDropdown()}>
      <span className={hasFocus || value ? classes.smallText : classes.bigText}>{label}</span>
      <input
        id={id}
        ref={inputRef}
        type="text"
        value={value}
        placeholder={placeholder}
        autoComplete="off"
        onChange={onChangeHandler}
        onFocus={() => setHasFocus(true)}
        onBlur={() => setHasFocus(false)}
        onKeyDown={(e) => e.key === "Enter" && onClick()}
        onClick={onClickInputHandler}
      />
      {iata && <span className={classes.iata}>{iata}</span>}
    </label>
  );
});
